/* document.addEventListener("DOMContentLoaded", function () {
 

  function addVerifiedBuyerSpan() {
     var container = document.querySelector(".jdgm-all-reviews__body");
    if (container) {
      var authors = container.querySelectorAll(".jdgm-rev__author");
      authors.forEach(function (author) {
        var verifiedBuyerSpan = document.createElement("span");
        verifiedBuyerSpan.textContent = ". Verified Buyer";
        verifiedBuyerSpan.style.fontSize = "11px";
        verifiedBuyerSpan.style.color = "#2323239c";
        author.appendChild(verifiedBuyerSpan);
      });
    }
  }

  addVerifiedBuyerSpan();

}); */

/* document.addEventListener("DOMContentLoaded", function () {

  function addVerifiedBuyerSpan(author) {
    var verifiedBuyerSpan = document.createElement("span");
    verifiedBuyerSpan.textContent = ". Verified Buyer";
    verifiedBuyerSpan.style.fontSize = "11px";
    verifiedBuyerSpan.style.color = "#2323239c";
    
    // Check if the author already has a "Verified Buyer" span
    if (!author.querySelector('.verified-buyer-span')) {
      verifiedBuyerSpan.classList.add('verified-buyer-span'); // Add a class for identification
      author.appendChild(verifiedBuyerSpan);
    }
  }

  function handleLoadMoreReviews(event) {
    // Check if the clicked element is the "More Reviews" button
    if (event.target.classList.contains('jdgm-all-reviews-page__load-more')) {
      var container = document.querySelector(".jdgm-all-reviews__body");
      if (container) {
        var newAuthors = container.querySelectorAll(".jdgm-rev__author:not(.verified-buyer-span)");
        newAuthors.forEach(function (author) {
          addVerifiedBuyerSpan(author);
        });
      }
    }
  }

  // Add event listener for clicks on the document
  document.addEventListener('click', handleLoadMoreReviews);

  // Call the function to add "Verified Buyer" spans initially
  var initialAuthors = document.querySelectorAll(".jdgm-rev__author");
  initialAuthors.forEach(function (author) {
    addVerifiedBuyerSpan(author);
  });

}); */



/* document.addEventListener("DOMContentLoaded", function () {

  function addVerifiedBuyerSpan(author) {
    var verifiedBuyerSpan = document.createElement("span");
    verifiedBuyerSpan.textContent = ". Verified Buyer";
    verifiedBuyerSpan.style.fontSize = "11px";
    verifiedBuyerSpan.style.color = "#2323239c";
    
    // Check if the author already has a "Verified Buyer" span
    if (!author.querySelector('.verified-buyer-span')) {
      verifiedBuyerSpan.classList.add('verified-buyer-span'); // Add a class for identification
      author.appendChild(verifiedBuyerSpan);
    }
  }

  function handleLoadMoreReviews(event) {
    // Check if the clicked element is the "More Reviews" button
    if (event.target.classList.contains('jdgm-all-reviews-page__load-more')) {
      var container = document.querySelector(".jdgm-all-reviews__body");
      if (container) {
        var newAuthors = container.querySelectorAll(".jdgm-rev__author:not(.verified-buyer-span)");
        newAuthors.forEach(function (author) {
          addVerifiedBuyerSpan(author);
        });
      }
    }
  }

  // Call the function to add "Verified Buyer" spans initially
  var initialAuthors = document.querySelectorAll(".jdgm-rev__author");
  initialAuthors.forEach(function (author) {
    addVerifiedBuyerSpan(author);
  });

  // Add event listener for clicks on the document
  document.addEventListener('click', handleLoadMoreReviews);

  // Trigger the "More Reviews" button click event once after the page loads
  var loadMoreButton = document.querySelector('.jdgm-all-reviews-page__load-more');
  if (loadMoreButton) {
    loadMoreButton.click();
  }

}); */




document.addEventListener("DOMContentLoaded", function () {


  function addVerifiedBuyerSpan(author) {
    var verifiedBuyerSpan = document.createElement("span");
    verifiedBuyerSpan.textContent = ". Verified Buyer";
    verifiedBuyerSpan.style.fontSize = "11px";
    verifiedBuyerSpan.style.color = "#2323239c";
    
    // Check if the author already has a "Verified Buyer" span
    if (!author.querySelector('.verified-buyer-span')) {
      verifiedBuyerSpan.classList.add('verified-buyer-span'); // Add a class for identification
      author.appendChild(verifiedBuyerSpan);
    }
  }

  function handleLoadMoreReviews(event) {
    // Check if the clicked element is the "More Reviews" button
    if (event.target.classList.contains('jdgm-all-reviews-page__load-more')) {
      var container = document.querySelector(".jdgm-all-reviews__body");
      if (container) {
        var newAuthors = container.querySelectorAll(".jdgm-rev__author:not(.verified-buyer-span)");
        newAuthors.forEach(function (author) {
          addVerifiedBuyerSpan(author);
        });
      }
    }
  }

  // Call the function to add "Verified Buyer" spans initially
  var initialAuthors = document.querySelectorAll(".jdgm-rev__author");
  initialAuthors.forEach(function (author) {
    addVerifiedBuyerSpan(author);
  });

  // Add event listener for clicks on the "More Reviews" button
  document.addEventListener('click', handleLoadMoreReviews);

  // Trigger the "More Reviews" button click event once after the page loads
  var loadMoreButton = document.querySelector('.jdgm-all-reviews-page__load-more');
  if (loadMoreButton) {
    loadMoreButton.click();
  }

  // Add a MutationObserver to detect changes in the review container
  var observer = new MutationObserver(function(mutationsList) {
    mutationsList.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // New reviews added, add "Verified Buyer" spans to them
        var newAuthors = document.querySelectorAll(".jdgm-rev__author:not(.verified-buyer-span)");
        newAuthors.forEach(function (author) {
          addVerifiedBuyerSpan(author);
        });
      }
    });
  });

  // Start observing changes in the review container
  var reviewContainer = document.querySelector(".jdgm-all-reviews__body");
  if (reviewContainer) {
    observer.observe(reviewContainer, { childList: true });
  }

});


